import { GuestDetails as GuestDetailsModule } from "../modules/GuestDetails/GuestDetails";

const GuestDetails = () => {
  return <GuestDetailsModule />;
};

export default GuestDetails;
